<template>
  <div class="successPage">
    <HeaderTop ref="shopcar"></HeaderTop>
    <!-- 页头标题板块 -->
    <div class="allTitle">
      <div class="titleCenter">
        <div class="left">
          <img src="../../../../../assets/images/home/logo1.png" alt="" />
          <span>商品维护</span>
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <div class="center">
      <div class="top">
        <span class="iconfont icon-a-lujing2281"></span>
        <p>商品上架成功</p>
      </div>
      <span class="text"
        >页面将在{{ num }}s后自动<span class="close" @click="backLast"
          >关闭</span
        >......</span
      >
    </div>
  </div>
</template>

<script>
import HeaderTop from '../../../../base/common/header-top.vue'
export default {
  components: {
    HeaderTop
  },

  data() {
    return {
      num: 10
    }
  },
  mounted() {},
  created() {
    this.backByself()
  },
  methods: {
    backByself() {
      let timer = setInterval(() => {
        this.num--
        if (this.num <= 0) {
          clearInterval(timer)
          this.$router.push({
            path: '/goodsList'
          })
        }
      }, 1000)
    },
    backLast() {
      this.$router.push({
        path: '/goodsList'
      })
    }
  }
}
</script>

<style lang="less" scoped>
.successPage {
  width: 100%;
  height: 100%;
}
.allTitle {
  width: 100%;
  height: 100px;
  padding-top: 40px;

  background-color: #fff;
  z-index: 99;
  display: flex;
  flex-direction: column;
  align-items: center;
  .titleCenter {
    background-color: #fff;
    width: 1200px;
    padding: 42px 0 8px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      display: flex;
      align-items: center;
      img {
        width: 121px;
        height: 34px;
        margin-right: 5px;
      }
      span {
        font-size: 30px;
        font-weight: bold;
        color: #787878;
      }
    }
  }
}
.center {
  margin-top: 100px;
  font-weight: bold;
  .text {
    margin-left: 50px;
  }
  .top {
    display: flex;
    justify-content: left;
    align-items: center;
    margin-bottom: 20px;
    span {
      color: #62b72f;
      font-size: 26px;
      margin-right: 20px;
    }
    p {
      font-size: 18px;
    }
  }
  .close {
    color: #48a4e4;
    cursor: pointer;
  }
}
</style>
